(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-reviews')) {
    customElements.define('lp-reviews', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-carousel')) return;
        this.track = this.querySelector('.lp-reviews__track');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.position = this.querySelector('[data-position]');
        this.dots = [...this.querySelectorAll('[data-slide-index]')];
        this.index = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideIndex)), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-review-card]');
          const index = this.cards.indexOf(card);
          if (index >= 0) this.goTo(index, 'auto');
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }
      goTo(index, behavior) {
        this.measure();
        const target = Math.max(0, Math.min(index, this.maxIndex));
        this.track.scrollTo({
          left: target * this.step,
          behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth')
        });
      }
      measure() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const cardWidth = this.cards[0]?.getBoundingClientRect().width || this.track.clientWidth;
        this.step = cardWidth + gap;
        const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / this.step));
        this.maxIndex = Math.max(0, this.cards.length - visibleCards);
      }
      update() {
        this.measure();
        this.index = Math.min(this.maxIndex, Math.round(this.track.scrollLeft / (this.step || 1)));
        if (this.previous) this.previous.disabled = this.index <= 0;
        if (this.next) this.next.disabled = this.index >= this.maxIndex;
        if (this.position) this.position.textContent = `${this.index + 1} / ${this.maxIndex + 1}`;
        this.dots.forEach((dot) => {
          dot.hidden = Number(dot.dataset.slideIndex) > this.maxIndex;
          if (Number(dot.dataset.slideIndex) === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
